export const STRING_REG_EXP = /^[a-zA-Z\u0400-\u04FF.()&\s]+$/;
export const PHONE_REG_EXP = /^(\+[0-9]{1,20}|)$/;
export const FILE_NAME_GER_EXP = /\.[^/.]+$/;
export const DECIMAL_REG_EXP = /^(\d*|\d+\.\d{0,3}|\d*\.\d{1,3})$/;
export const IMAGE_REG_EXP = /\.(jpe?g|png|gif|bmp)$/i;
export const VIDEO_REG_EXP = /\.(m4v|avi|mpg|mp4|webm|MOV)$/i;
